import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { OrganismosNocivosPopupComponent } from '../../../core/components/popup/organismosnocivos/organismosNocivosPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { WOrganismosNocivosExtendedViewModel } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcDecisionInspeccion, EnumTipoExentoCertificacionCpe } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudCpeService } from '../datosbasicos/cpe.service';
import { CertificacionService } from './certificacion.service';
import { CertificacionCpeViewModel, CheckExentoViewModel, SolicitudCpeCertificacionViewModel } from './certificacion.types';

@Component({
    selector: 'app-certificacion-edit',
    templateUrl: './certificacion-edit.component.html',
})
export class CertificacionEditComponent extends ComponentBase implements OnInit {
    @ViewChild(OrganismosNocivosPopupComponent)
    private organismoNocivoPopupComponent: OrganismosNocivosPopupComponent;

    editMode = false;

    habilitarGuardar = true;
    habilitarEdicion = true;
    habilitarBusquedaOrganismoNocivoA = false;
    habilitarBusquedaOrganismoNocivoB = false;
    habilitarBusquedaOrganismoNocivoC = false;
    habilitarBusquedaOrganismoNocivoD = false;
    habilitarBusquedaOrganismoNocivoE = false;
    habilitarBusquedaOrganismoNocivoF = false;
    habilitarBusquedaOrganismoNocivoG = false;

    //certificacionCpe: CertificacionCpeViewModel;
    solicitudCpeCertificacion: SolicitudCpeCertificacionViewModel;

    tituloEstadoSolicitud: string;

    visibilitySpinner = false;
    IdEstadoSolicitudCpe: number;
    codigo: string;

    //esComunidad: boolean = false;
    IdCpe: number;
    //IdOrganismoNocivo: number;

    campoObligatorio = false;

    listboxExentoA: CheckExentoViewModel[];
    numerolistboxExentoA = 0;
    listboxExentoB: CheckExentoViewModel[];
    numerolistboxExentoB = 0;
    listboxExentoC: CheckExentoViewModel[];
    numerolistboxExentoC = 0;
    listboxExentoD: CheckExentoViewModel[];
    numerolistboxExentoD = 0;
    listboxExentoE: CheckExentoViewModel[];
    numerolistboxExentoE = 0;
    listboxExentoF: CheckExentoViewModel[];
    numerolistboxExentoF = 0;
    listboxExentoG: CheckExentoViewModel[];
    numerolistboxExentoG = 0;

    //fechaEmision: string | null = null;
    //fechaRechazo: string | null = null;
    fechaFinalizacion: string | null = null;

    public isCollapsedResolucion = false;
    public isCollapsedOtrosDatos = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,

        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private navMenuService: NavMenuService,
        private certificacionService: CertificacionService,
        private cpeService: SolicitudCpeService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        //this.certificacionCpe = new CertificacionCpeViewModel();
        this.solicitudCpeCertificacion = new SolicitudCpeCertificacionViewModel();
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];

        this.IdCpe = id;

        this.guardRefreshPage(id);

        this.createForm();

        //Siempre tendrá un id.
        if (id) {
            this.loading = true;

            //recuperar la solicitud
            this.certificacionService.getSolicitudCpeCertificacion(id).subscribe(result => {
                this.solicitudCpeCertificacion = result;

                this.tituloEstadoSolicitud = this.solicitudCpeCertificacion.IdEstadoSolicitudCpeDescripcion;
                this.IdEstadoSolicitudCpe = this.solicitudCpeCertificacion.IdEstadoSolicitudCpe;
                this.codigo = this.solicitudCpeCertificacion.Codigo;

                //this.fechaFinalizacion = this.datepipe.transform(result.FechaFinalizacion, 'dd/MM/yyyy HH:mm:ss');
                this.fechaFinalizacion =
                    this.solicitudCpeCertificacion.FechaEmision != null
                        ? this.datepipe.transform(this.solicitudCpeCertificacion.FechaEmision, 'dd/MM/yyyy HH:mm:ss')
                        : this.solicitudCpeCertificacion.FechaRechazo != null
                          ? this.datepipe.transform(this.solicitudCpeCertificacion.FechaRechazo, 'dd/MM/yyyy HH:mm:ss')
                          : null;

                //checkExentoA
                this.listboxExentoA =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoAOrgNocivoCollection
                        : new Array<CheckExentoViewModel>();
                this.numerolistboxExentoA =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoAOrgNocivoCollection.length
                        : 0;
                //checkExentoB
                this.listboxExentoB =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoBOrgNocivoCollection
                        : new Array<CheckExentoViewModel>();
                this.numerolistboxExentoB =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoBOrgNocivoCollection.length
                        : 0;
                //checkExentoC
                this.listboxExentoC =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoCOrgNocivoCollection
                        : new Array<CheckExentoViewModel>();
                this.numerolistboxExentoC =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoCOrgNocivoCollection.length
                        : 0;
                //checkExentoD
                this.listboxExentoD =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoDOrgNocivoCollection
                        : new Array<CheckExentoViewModel>();
                this.numerolistboxExentoD =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoDOrgNocivoCollection.length
                        : 0;
                //checkExentoE
                this.listboxExentoE =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoEOrgNocivoCollection
                        : new Array<CheckExentoViewModel>();
                this.numerolistboxExentoE =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoEOrgNocivoCollection.length
                        : 0;
                //checkExentoF
                this.listboxExentoF =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoFOrgNocivoCollection
                        : new Array<CheckExentoViewModel>();
                this.numerolistboxExentoF =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoFOrgNocivoCollection.length
                        : 0;
                //checkExentoG
                this.listboxExentoG =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoGOrgNocivoCollection
                        : new Array<CheckExentoViewModel>();
                this.numerolistboxExentoG =
                    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                        ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoGOrgNocivoCollection.length
                        : 0;

                this.updateForm();

                this.loading = false;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_CERTIFICACION_CPE,
                    this.solicitudCpeCertificacion.IdEstadoSolicitudCpe,
                ).Editable;
                this.habilitarEdicion = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_CERTIFICACION_CPE,
                    this.solicitudCpeCertificacion.IdEstadoSolicitudCpe,
                ).Editable;

                if (!this.habilitarEdicion) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                }
            });
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudCpe.Id) || this.navMenuService.currentSolicitudCpe.Id !== id) {
            this.cpeService.getSolicitudCpe(id).subscribe(result => {
                this.navMenuService.currentSolicitudCpe = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            CheckCumpleRequisitos: false,
            CumpleRequisitos: '',
            CheckInspeccionOficial: false,
            InspeccionOficial: '',
            CheckAnalisisOficial: false,
            AnalisisOficial: '',
            CheckExentoA: false,
            CheckExentoB: false,
            CheckExentoC: false,
            CheckExentoD: false,
            CheckExentoE: false,
            CheckExentoF: false,
            CheckExentoG: false,
            ListExentoA: null,
            ListExentoB: null,
            ListExentoC: null,
            ListExentoD: null,
            ListExentoE: null,
            ListExentoF: null,
            ListExentoG: null,

            CheckExentoEspecificacionesAyG: false,
            EspecificacionesAyG: '',

            OtraInformacionOficial: '',
            LugarExpedicion: ['', Validators.required],
            DatosContacto: ['', Validators.required],
            Observaciones: '',

            IdDecision: null,
        });
    }

    updateForm() {
        this.form.setValue({
            CheckCumpleRequisitos:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckCumpleRequisitos
                    : false,
            CumpleRequisitos:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CumpleRequisitos
                    : '',
            CheckInspeccionOficial:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckInspeccionOficial
                    : false,
            InspeccionOficial:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.InspeccionOficial
                    : '',
            CheckAnalisisOficial:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckAnalisisOficial
                    : false,
            AnalisisOficial:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.AnalisisOficial
                    : '',
            CheckExentoA:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoA
                    : false,
            CheckExentoB:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoB
                    : false,
            CheckExentoC:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoC
                    : false,
            CheckExentoD:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoD
                    : false,
            CheckExentoE:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoE
                    : false,
            CheckExentoF:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoF
                    : false,
            CheckExentoG:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoG
                    : false,

            ListExentoA: null,
            ListExentoB: null,
            ListExentoC: null,
            ListExentoD: null,
            ListExentoE: null,
            ListExentoF: null,
            ListExentoG: null,

            CheckExentoEspecificacionesAyG:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoEspecificacionesAyG
                    : false,
            EspecificacionesAyG:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.EspecificacionesAyG
                    : '',

            OtraInformacionOficial:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.OtraInformacionOficial
                    : '',
            LugarExpedicion:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.LugarExpedicion
                    : '',
            DatosContacto:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.DatosContacto
                    : '',
            Observaciones:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.Observaciones
                    : '',

            IdDecision:
                this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx != null
                    ? this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.IdDecision == EnumIdsTwTcDecisionInspeccion.ACEPTAR
                        ? 'A'
                        : this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.IdDecision == EnumIdsTwTcDecisionInspeccion.RECHAZAR
                          ? 'R'
                          : null
                    : null,

            //IdDecision: this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.IdDecision == EnumIdsTwTcDecisionInspeccion.ACEPTAR ? 'A' :
            //    this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.IdDecision == EnumIdsTwTcDecisionInspeccion.RECHAZAR ? 'R' :
            //        this.solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.IdDecision == EnumIdsTwTcDecisionInspeccion.NO_PROCEDE ? 'N' : null,
        });
        this.onChangeCumpleRequisitos();
        this.onChangeInspeccionOficial();
        this.onChangeAnalisisOficial();
        this.onChangeExentoA();
        this.onChangeExentoB();
        this.onChangeExentoC();
        this.onChangeExentoD();
        this.onChangeExentoE();
        this.onChangeExentoF();
        this.onChangeExentoG();
        this.onChangeEspecificacionesAyG();
    }

    private DisableControlsConsulta() {
        this.form.controls['CheckCumpleRequisitos'].disable();
        this.form.controls['CumpleRequisitos'].disable();
        this.form.controls['CheckInspeccionOficial'].disable();
        this.form.controls['InspeccionOficial'].disable();
        this.form.controls['CheckAnalisisOficial'].disable();
        this.form.controls['AnalisisOficial'].disable();
        this.form.controls['CheckExentoA'].disable();
        this.form.controls['CheckExentoB'].disable();
        this.form.controls['CheckExentoC'].disable();
        this.form.controls['CheckExentoD'].disable();
        this.form.controls['CheckExentoE'].disable();
        this.form.controls['CheckExentoF'].disable();
        this.form.controls['CheckExentoG'].disable();
        this.form.controls['CheckExentoEspecificacionesAyG'].disable();

        this.form.controls['OtraInformacionOficial'].disable();
        this.form.controls['LugarExpedicion'].disable();
        this.form.controls['DatosContacto'].disable();
        this.form.controls['Observaciones'].disable();

        this.form.controls['IdDecision'].disable();

        this.habilitarBusquedaOrganismoNocivoA = false;
        this.habilitarBusquedaOrganismoNocivoB = false;
        this.habilitarBusquedaOrganismoNocivoC = false;
        this.habilitarBusquedaOrganismoNocivoD = false;
        this.habilitarBusquedaOrganismoNocivoE = false;
        this.habilitarBusquedaOrganismoNocivoF = false;
        this.habilitarBusquedaOrganismoNocivoG = false;
    }

    onChangeCumpleRequisitos() {
        if (this.form.value.CheckCumpleRequisitos) {
            this.form.controls['CumpleRequisitos'].enable();
            this.addValidator('CumpleRequisitos', Validators.required);
        } else {
            this.form.controls['CumpleRequisitos'].disable();
            this.removeValidators('CumpleRequisitos');
        }
    }

    onChangeInspeccionOficial() {
        if (this.form.value.CheckInspeccionOficial) {
            this.form.controls['InspeccionOficial'].enable();
            this.addValidator('InspeccionOficial', Validators.required);
        } else {
            this.form.controls['InspeccionOficial'].disable();
            this.removeValidators('InspeccionOficial');
        }
    }

    onChangeAnalisisOficial() {
        if (this.form.value.CheckAnalisisOficial) {
            this.form.controls['AnalisisOficial'].enable();
            this.addValidator('AnalisisOficial', Validators.required);
        } else {
            this.form.controls['AnalisisOficial'].disable();
            this.removeValidators('AnalisisOficial');
        }
    }

    onChangeExentoA() {
        if (this.form.value.CheckExentoA) {
            this.habilitarBusquedaOrganismoNocivoA = true;

            this.addValidator('ListExentoA', Validators.required);
        } else {
            if (this.listboxExentoA.length > 0) {
                this.confirmationService.confirm({
                    message: 'Tiene organismos nocivos seleccionados, si continua se borrarán de la lista',
                    accept: () => {
                        this.listboxExentoA = new Array<CheckExentoViewModel>();
                        this.numerolistboxExentoA = 0;
                        this.habilitarBusquedaOrganismoNocivoA = false;
                        this.removeValidators('ListExentoA');
                    },
                    reject: () => {
                        this.form.patchValue({
                            CheckExentoA: true,
                        });
                    },
                });
            } else {
                this.habilitarBusquedaOrganismoNocivoA = false;
                this.removeValidators('ListExentoA');
            }
        }
    }

    onChangeExentoB() {
        if (this.form.value.CheckExentoB) {
            this.habilitarBusquedaOrganismoNocivoB = true;

            this.addValidator('ListExentoB', Validators.required);
        } else {
            if (this.listboxExentoB.length > 0) {
                this.confirmationService.confirm({
                    message: 'Tiene organismos nocivos seleccionados, si continua se borrarán de la lista',
                    accept: () => {
                        this.listboxExentoB = new Array<CheckExentoViewModel>();
                        this.numerolistboxExentoB = 0;
                        this.habilitarBusquedaOrganismoNocivoB = false;
                        this.removeValidators('ListExentoB');
                    },
                    reject: () => {
                        this.form.patchValue({
                            CheckExentoB: true,
                        });
                    },
                });
            } else {
                this.habilitarBusquedaOrganismoNocivoB = false;
                this.removeValidators('ListExentoB');
            }
        }
    }

    onChangeExentoC() {
        if (this.form.value.CheckExentoC) {
            this.habilitarBusquedaOrganismoNocivoC = true;

            this.addValidator('ListExentoC', Validators.required);
        } else {
            if (this.listboxExentoC.length > 0) {
                this.confirmationService.confirm({
                    message: 'Tiene organismos nocivos seleccionados, si continua se borrarán de la lista',
                    accept: () => {
                        this.listboxExentoC = new Array<CheckExentoViewModel>();
                        this.numerolistboxExentoC = 0;
                        this.habilitarBusquedaOrganismoNocivoC = false;
                        this.removeValidators('ListExentoC');
                    },
                    reject: () => {
                        this.form.patchValue({
                            CheckExentoC: true,
                        });
                    },
                });
            } else {
                this.habilitarBusquedaOrganismoNocivoC = false;
                this.removeValidators('ListExentoC');
            }
        }
    }

    onChangeExentoD() {
        if (this.form.value.CheckExentoD) {
            this.habilitarBusquedaOrganismoNocivoD = true;

            this.addValidator('ListExentoD', Validators.required);
        } else {
            if (this.listboxExentoD.length > 0) {
                this.confirmationService.confirm({
                    message: 'Tiene organismos nocivos seleccionados, si continua se borrarán de la lista',
                    accept: () => {
                        this.listboxExentoD = new Array<CheckExentoViewModel>();
                        this.numerolistboxExentoD = 0;
                        this.habilitarBusquedaOrganismoNocivoD = false;
                        this.removeValidators('ListExentoD');
                    },
                    reject: () => {
                        this.form.patchValue({
                            CheckExentoD: true,
                        });
                    },
                });
            } else {
                this.habilitarBusquedaOrganismoNocivoD = false;
                this.removeValidators('ListExentoD');
            }
        }
    }

    onChangeExentoE() {
        if (this.form.value.CheckExentoE) {
            this.habilitarBusquedaOrganismoNocivoE = true;

            this.addValidator('ListExentoE', Validators.required);
        } else {
            if (this.listboxExentoE.length > 0) {
                this.confirmationService.confirm({
                    message: 'Tiene organismos nocivos seleccionados, si continua se borrarán de la lista',
                    accept: () => {
                        this.listboxExentoE = new Array<CheckExentoViewModel>();
                        this.numerolistboxExentoE = 0;
                        this.habilitarBusquedaOrganismoNocivoE = false;
                        this.removeValidators('ListExentoE');
                    },
                    reject: () => {
                        this.form.patchValue({
                            CheckExentoE: true,
                        });
                    },
                });
            } else {
                this.habilitarBusquedaOrganismoNocivoE = false;
                this.removeValidators('ListExentoE');
            }
        }
    }

    onChangeExentoF() {
        if (this.form.value.CheckExentoF) {
            this.habilitarBusquedaOrganismoNocivoF = true;

            this.addValidator('ListExentoF', Validators.required);
        } else {
            if (this.listboxExentoF.length > 0) {
                this.confirmationService.confirm({
                    message: 'Tiene organismos nocivos seleccionados, si continua se borrarán de la lista',
                    accept: () => {
                        this.listboxExentoF = new Array<CheckExentoViewModel>();
                        this.numerolistboxExentoF = 0;
                        this.habilitarBusquedaOrganismoNocivoF = false;
                        this.removeValidators('ListExentoF');
                    },
                    reject: () => {
                        this.form.patchValue({
                            CheckExentoF: true,
                        });
                    },
                });
            } else {
                this.habilitarBusquedaOrganismoNocivoF = false;
                this.removeValidators('ListExentoF');
            }
        }
    }

    onChangeExentoG() {
        if (this.form.value.CheckExentoG) {
            this.habilitarBusquedaOrganismoNocivoG = true;

            this.addValidator('ListExentoG', Validators.required);
        } else {
            if (this.listboxExentoG.length > 0) {
                this.confirmationService.confirm({
                    message: 'Tiene organismos nocivos seleccionados, si continua se borrarán de la lista',
                    accept: () => {
                        this.listboxExentoG = new Array<CheckExentoViewModel>();
                        this.numerolistboxExentoG = 0;
                        this.habilitarBusquedaOrganismoNocivoG = false;
                        this.removeValidators('ListExentoG');
                    },
                    reject: () => {
                        this.form.patchValue({
                            CheckExentoG: true,
                        });
                    },
                });
            } else {
                this.habilitarBusquedaOrganismoNocivoG = false;
                this.removeValidators('ListExentoG');
            }
        }
    }

    onChangeEspecificacionesAyG() {
        if (this.form.value.CheckExentoEspecificacionesAyG) {
            this.form.controls['EspecificacionesAyG'].enable();
            this.addValidator('EspecificacionesAyG', Validators.required);
        } else {
            this.form.controls['EspecificacionesAyG'].disable();
            this.removeValidators('EspecificacionesAyG');
        }
    }

    onSearchOrganismoNocivo(tipoExento: string) {
        this.organismoNocivoPopupComponent.showDialog(tipoExento, true);
    }

    onAceptDialogOrganismoNocivo(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        switch (organismoNocivo.TipoExento) {
            case EnumTipoExentoCertificacionCpe.CHECK_EXENTO_A:
                this.addItemListboxExentoA(organismoNocivo);
                break;
            case EnumTipoExentoCertificacionCpe.CHECK_EXENTO_B:
                this.addItemListboxExentoB(organismoNocivo);
                break;
            case EnumTipoExentoCertificacionCpe.CHECK_EXENTO_C:
                this.addItemListboxExentoC(organismoNocivo);
                break;
            case EnumTipoExentoCertificacionCpe.CHECK_EXENTO_D:
                this.addItemListboxExentoD(organismoNocivo);
                break;
            case EnumTipoExentoCertificacionCpe.CHECK_EXENTO_E:
                this.addItemListboxExentoE(organismoNocivo);
                break;
            case EnumTipoExentoCertificacionCpe.CHECK_EXENTO_F:
                this.addItemListboxExentoF(organismoNocivo);
                break;
            case EnumTipoExentoCertificacionCpe.CHECK_EXENTO_G:
                this.addItemListboxExentoG(organismoNocivo);
                break;

            default:
                break;
        }

        //this.IdOrganismoNocivo = organismoNocivo.Id;
    }

    addItemListboxExentoA(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        let currentExentoA = new CheckExentoViewModel();
        currentExentoA.IdCertPrevioEx = this.IdCpe;
        currentExentoA.IdOrganismoNocivo = organismoNocivo.Id;
        currentExentoA.OrganismoNocivoDescripcion = organismoNocivo.FullName;
        if (this.listboxExentoA == null) {
            this.listboxExentoA = new Array<CheckExentoViewModel>();
        }
        let yaIncluido = this.listboxExentoA.find(it => it.IdOrganismoNocivo == currentExentoA.IdOrganismoNocivo);
        if (yaIncluido) {
            return;
        }
        this.listboxExentoA.push(currentExentoA);
        this.numerolistboxExentoA = this.listboxExentoA.length;

        this.removeValidators('ListExentoA');
    }

    onDeleteOrgNocivoExentoA(item: CheckExentoViewModel) {
        //alert(this.listboxExentoA.indexOf(item));
        this.listboxExentoA.splice(this.listboxExentoA.indexOf(item), 1);
        this.numerolistboxExentoA = this.listboxExentoA.length;

        if (this.numerolistboxExentoA == 0) {
            this.addValidator('ListExentoA', Validators.required);
        }
    }

    addItemListboxExentoB(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        let currentExentoB = new CheckExentoViewModel();
        currentExentoB.IdCertPrevioEx = this.IdCpe;
        currentExentoB.IdOrganismoNocivo = organismoNocivo.Id;
        currentExentoB.OrganismoNocivoDescripcion = organismoNocivo.FullName;
        if (this.listboxExentoB == null) {
            this.listboxExentoB = new Array<CheckExentoViewModel>();
        }
        let yaIncluido = this.listboxExentoB.find(it => it.IdOrganismoNocivo == currentExentoB.IdOrganismoNocivo);
        if (yaIncluido) {
            return;
        }
        this.listboxExentoB.push(currentExentoB);
        this.numerolistboxExentoB = this.listboxExentoB.length;

        this.removeValidators('ListExentoB');
    }

    onDeleteOrgNocivoExentoB(item: CheckExentoViewModel) {
        this.listboxExentoB.splice(this.listboxExentoB.indexOf(item), 1);
        this.numerolistboxExentoB = this.listboxExentoB.length;

        if (this.numerolistboxExentoB == 0) {
            this.addValidator('ListExentoB', Validators.required);
        }
    }

    addItemListboxExentoC(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        let currentExentoC = new CheckExentoViewModel();
        currentExentoC.IdCertPrevioEx = this.IdCpe;
        currentExentoC.IdOrganismoNocivo = organismoNocivo.Id;
        currentExentoC.OrganismoNocivoDescripcion = organismoNocivo.FullName;
        if (this.listboxExentoC == null) {
            this.listboxExentoC = new Array<CheckExentoViewModel>();
        }
        let yaIncluido = this.listboxExentoC.find(it => it.IdOrganismoNocivo == currentExentoC.IdOrganismoNocivo);
        if (yaIncluido) {
            return;
        }
        this.listboxExentoC.push(currentExentoC);
        this.numerolistboxExentoC = this.listboxExentoC.length;

        this.removeValidators('ListExentoC');
    }

    onDeleteOrgNocivoExentoC(item: CheckExentoViewModel) {
        this.listboxExentoC.splice(this.listboxExentoC.indexOf(item), 1);
        this.numerolistboxExentoC = this.listboxExentoC.length;

        if (this.numerolistboxExentoC == 0) {
            this.addValidator('ListExentoC', Validators.required);
        }
    }

    addItemListboxExentoD(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        let currentExentoD = new CheckExentoViewModel();
        currentExentoD.IdCertPrevioEx = this.IdCpe;
        currentExentoD.IdOrganismoNocivo = organismoNocivo.Id;
        currentExentoD.OrganismoNocivoDescripcion = organismoNocivo.FullName;
        if (this.listboxExentoD == null) {
            this.listboxExentoD = new Array<CheckExentoViewModel>();
        }
        let yaIncluido = this.listboxExentoD.find(it => it.IdOrganismoNocivo == currentExentoD.IdOrganismoNocivo);
        if (yaIncluido) {
            return;
        }
        this.listboxExentoD.push(currentExentoD);
        this.numerolistboxExentoD = this.listboxExentoD.length;

        this.removeValidators('ListExentoD');
    }

    onDeleteOrgNocivoExentoD(item: CheckExentoViewModel) {
        this.listboxExentoD.splice(this.listboxExentoD.indexOf(item), 1);
        this.numerolistboxExentoD = this.listboxExentoD.length;

        if (this.numerolistboxExentoD == 0) {
            this.addValidator('ListExentoD', Validators.required);
        }
    }

    addItemListboxExentoE(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        let currentExentoE = new CheckExentoViewModel();
        currentExentoE.IdCertPrevioEx = this.IdCpe;
        currentExentoE.IdOrganismoNocivo = organismoNocivo.Id;
        currentExentoE.OrganismoNocivoDescripcion = organismoNocivo.FullName;
        if (this.listboxExentoE == null) {
            this.listboxExentoE = new Array<CheckExentoViewModel>();
        }
        let yaIncluido = this.listboxExentoE.find(it => it.IdOrganismoNocivo == currentExentoE.IdOrganismoNocivo);
        if (yaIncluido) {
            return;
        }
        this.listboxExentoE.push(currentExentoE);
        this.numerolistboxExentoE = this.listboxExentoE.length;

        this.removeValidators('ListExentoE');
    }

    onDeleteOrgNocivoExentoE(item: CheckExentoViewModel) {
        this.listboxExentoE.splice(this.listboxExentoE.indexOf(item), 1);
        this.numerolistboxExentoE = this.listboxExentoE.length;

        if (this.numerolistboxExentoE == 0) {
            this.addValidator('ListExentoE', Validators.required);
        }
    }

    addItemListboxExentoF(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        let currentExentoF = new CheckExentoViewModel();
        currentExentoF.IdCertPrevioEx = this.IdCpe;
        currentExentoF.IdOrganismoNocivo = organismoNocivo.Id;
        currentExentoF.OrganismoNocivoDescripcion = organismoNocivo.FullName;
        if (this.listboxExentoF == null) {
            this.listboxExentoF = new Array<CheckExentoViewModel>();
        }
        let yaIncluido = this.listboxExentoF.find(it => it.IdOrganismoNocivo == currentExentoF.IdOrganismoNocivo);
        if (yaIncluido) {
            return;
        }
        this.listboxExentoF.push(currentExentoF);
        this.numerolistboxExentoF = this.listboxExentoF.length;

        this.removeValidators('ListExentoF');
    }

    onDeleteOrgNocivoExentoF(item: CheckExentoViewModel) {
        this.listboxExentoF.splice(this.listboxExentoF.indexOf(item), 1);
        this.numerolistboxExentoF = this.listboxExentoF.length;

        if (this.numerolistboxExentoF == 0) {
            this.addValidator('ListExentoF', Validators.required);
        }
    }

    addItemListboxExentoG(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        let currentExentoG = new CheckExentoViewModel();
        currentExentoG.IdCertPrevioEx = this.IdCpe;
        currentExentoG.IdOrganismoNocivo = organismoNocivo.Id;
        currentExentoG.OrganismoNocivoDescripcion = organismoNocivo.FullName;
        if (this.listboxExentoG == null) {
            this.listboxExentoG = new Array<CheckExentoViewModel>();
        }
        let yaIncluido = this.listboxExentoG.find(it => it.IdOrganismoNocivo == currentExentoG.IdOrganismoNocivo);
        if (yaIncluido) {
            return;
        }
        this.listboxExentoG.push(currentExentoG);
        this.numerolistboxExentoG = this.listboxExentoG.length;

        this.removeValidators('ListExentoG');
    }

    onDeleteOrgNocivoExentoG(item: CheckExentoViewModel) {
        this.listboxExentoG.splice(this.listboxExentoG.indexOf(item), 1);
        this.numerolistboxExentoG = this.listboxExentoG.length;

        if (this.numerolistboxExentoG == 0) {
            this.addValidator('ListExentoG', Validators.required);
        }
    }

    guardarCertificacion() {
        this.confirmationService.confirm({
            message: '¿Está seguro de guardar la certificación de la solicitud?.',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    revisionSolicitanteConfirm() {
        let mensajeRevision: string;
        if (this.form.value.Observaciones == '') {
            mensajeRevision = 'Va a devolver la solicitud al solicitante sin Observaciones guardadas, ¿está seguro?';
        } else {
            mensajeRevision = 'Va a devolver la solicitud al solicitante, ¿está seguro?';
        }

        this.confirmationService.confirm({
            message: mensajeRevision,
            accept: () => {
                let params = new HttpParams();

                params = params.append('idCpe', this.IdCpe.toString());
                params = params.append('idUsuario', this.loggedInUser!.Id.toString());

                this.certificacionService.revisionSolicitante(params).subscribe({
                    next: res => {
                        this.addSuccessMessage('Solicitud devuelta correctamente');
                        //this.firstInit = false;

                        this.ngOnInit();
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    onSelectedDecision() {
        if (this.form.value.IdDecision == 'R') {
            this.campoObligatorio = true;
            this.addValidator('Observaciones', Validators.required);
        } else {
            this.campoObligatorio = false;
            this.removeValidators('Observaciones');
        }
    }

    onSubmit() {
        //if (this.form.value.CheckExentoA && this.listboxExentoA.length == 0) {
        //    this.addValidator("ListExentoA", Validators.required);
        //}
        //if (this.form.value.CheckExentoB && this.listboxExentoB.length == 0) {
        //    this.addValidator("ListExentoB", Validators.required);
        //}
        //if (this.form.value.CheckExentoC && this.listboxExentoC.length == 0) {
        //    this.addValidator("ListExentoC", Validators.required);
        //}
        //if (this.form.value.CheckExentoD && this.listboxExentoD.length == 0) {
        //    this.addValidator("ListExentoD", Validators.required);
        //}
        //if (this.form.value.CheckExentoE && this.listboxExentoE.length == 0) {
        //    this.addValidator("ListExentoE", Validators.required);
        //}
        //if (this.form.value.CheckExentoF && this.listboxExentoF.length == 0) {
        //    this.addValidator("ListExentoF", Validators.required);
        //}
        //if (this.form.value.CheckExentoG && this.listboxExentoG.length == 0) {
        //    this.addValidator("ListExentoG", Validators.required);
        //}

        this.submitted = true;
        if (!this.form.valid) {
            this.addErrorMessage('Por favor, revise los datos de la certificación');
            this.isCollapsedResolucion = false;
            this.isCollapsedOtrosDatos = false;
            return;
        }
        this.visibilitySpinner = true;

        let solicitudCpeCertificacion = new SolicitudCpeCertificacionViewModel();

        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx = new CertificacionCpeViewModel();

        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckCumpleRequisitos = this.form.value.CheckCumpleRequisitos;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CumpleRequisitos = this.form.value.CumpleRequisitos;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckInspeccionOficial = this.form.value.CheckInspeccionOficial;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.InspeccionOficial = this.form.value.InspeccionOficial;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckAnalisisOficial = this.form.value.CheckAnalisisOficial;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.AnalisisOficial = this.form.value.AnalisisOficial;

        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.OtraInformacionOficial = this.form.value.OtraInformacionOficial;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.LugarExpedicion = this.form.value.LugarExpedicion;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.DatosContacto = this.form.value.DatosContacto;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.Observaciones = this.form.value.Observaciones;

        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoA = this.form.value.CheckExentoA;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoB = this.form.value.CheckExentoB;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoC = this.form.value.CheckExentoC;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoD = this.form.value.CheckExentoD;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoE = this.form.value.CheckExentoE;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoF = this.form.value.CheckExentoF;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoG = this.form.value.CheckExentoG;

        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.CheckExentoEspecificacionesAyG = this.form.value.CheckExentoEspecificacionesAyG;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.EspecificacionesAyG = this.form.value.EspecificacionesAyG;

        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.IdDecision =
            this.form.value.IdDecision == 'A' ? 1 : this.form.value.IdDecision == 'R' ? 2 : null;
        solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.IdCertPrevioEx = this.IdCpe;
        //Usuario Comunidad
        solicitudCpeCertificacion.IdUsuarioCa = this.loggedInUser!.Id;

        //LISTAS DE CHECKS
        if (this.listboxExentoA != null) {
            solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoAOrgNocivoCollection = this.listboxExentoA;
        }
        if (this.listboxExentoB != null) {
            solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoBOrgNocivoCollection = this.listboxExentoB;
        }
        if (this.listboxExentoC != null) {
            solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoCOrgNocivoCollection = this.listboxExentoC;
        }
        if (this.listboxExentoD != null) {
            solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoDOrgNocivoCollection = this.listboxExentoD;
        }
        if (this.listboxExentoE != null) {
            solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoEOrgNocivoCollection = this.listboxExentoE;
        }
        if (this.listboxExentoF != null) {
            solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoFOrgNocivoCollection = this.listboxExentoF;
        }
        if (this.listboxExentoG != null) {
            solicitudCpeCertificacion.TwCertificacionCertificadoPrevioEx.TwCheckExentoGOrgNocivoCollection = this.listboxExentoG;
        }

        solicitudCpeCertificacion.Id = this.IdCpe;

        this.certificacionService.editSolicitudCpeCertificacion(solicitudCpeCertificacion).subscribe({
            next: res => {
                this.addSuccessMessage('Certificación guardada correctamente');
                //this.onBack();
                this.visibilitySpinner = false;
                this.ngOnInit();
            },
            error: error => {
                this.isCollapsedResolucion = false;
                this.isCollapsedOtrosDatos = false;

                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }

    onBack() {
        this.router.navigate(['/exportacion/cpe/datosbasicos', this.IdCpe]);
    }
}
